import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { scroller } from 'react-scroll';
import { Translation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { Container, Row, Col, Jumbotron, Button } from 'react-bootstrap';
import AlertDialog from '../components/layout/AlertDialog';
import config from '../config';
import { getLang } from '../services/lang';
import axios from 'axios';
import { history } from '../_helpers';

import Modal from './layout/Modal';
import { addPreferredPharmacy } from '../actions/pharmacy';
import PharmacySelect from './layout/PharmacySelect';
import Utility from '../services/Utility';

const OSCAR_STATUS_POLL_INTERVAL_MS = 30000;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.offlineCounter = 0;
    this.url = '';
    this.mode = '';
    this._oscarStatusInterval = null;
    this.state = {
      user: this.props.user,
      shouldUpdate: this.props.user ? this.props.user.shouldUpdate : false,
      alert: '',
      isOscarOnline: true,
      isConnecting: false,
      isButtonDisabled: false,
      preferredPharmacyList: this.props.pharmacy.list,
      preferredPharmacy: '',
      showPharmacyModal: false,
      url: '',
      mode: ''
    };
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.componentCleanup.bind(this));
    this._scrollToTop();
    this._startOscarStatusPolling();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.componentCleanup.bind(this));
    this.componentCleanup();
  }

  componentCleanup() {
    if (this._oscarStatusInterval) {
      clearInterval(this._oscarStatusInterval);
      this._oscarStatusInterval = null;
    }
  }

  _startOscarStatusPolling() {
    this._pollOscarStatus();
    this._oscarStatusInterval = setInterval(() => this._pollOscarStatus(), OSCAR_STATUS_POLL_INTERVAL_MS);
  }

  async _pollOscarStatus() {
    try {
      const res = await axios.get(`${config.service}/services/oscarStatus`);
      if (res.data && res.data.status) {
        this._onlineHandler();
      } else {
        this._offlineHandler();
      }
    } catch (err) {
      if (!err.response) {
        this.setState({ isConnecting: true, isButtonDisabled: true });
      } else {
        this._offlineHandler();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('componentDidUpdate',this.props.user)
    if (!prevProps.user && this.props.user) {
      this.setState({
        user: this.props.user,
        shouldUpdate: this.props.user.shouldUpdate
      });
    }
    if (prevProps.pharmacy.list !== this.props.pharmacy.list) {
      console.log('pharmacy changed');
      this.setState({
        preferredPharmacyList: this.props.pharmacy.list
      });
    }
  }

  renderPharmacyMessage() {
    if (this.state.preferredPharmacyList.length == 0) return;

    return (
      <>
        <div id="preferred-pharmacy-container">
          <Row>
            <Col sm={12} md={12}>
              <PharmacySelect pharmacyList={this.state.preferredPharmacyList} onChange={this.onChange.bind(this)} name="preferredPharmacy" />
            </Col>
          </Row>
        </div>
      </>
    );
  }

  _offlineHandler() {
    if (!this.state.isOscarOnline && !this.state.isConnecting) {
      return;
    }
    this.setState({ isOscarOnline: false, isConnecting: false, isButtonDisabled: true });
  }

  _onlineHandler() {
    if (this.state.isOscarOnline && !this.state.isConnecting) {
      return;
    }
    this.setState({ isOscarOnline: true, isConnecting: false, isButtonDisabled: false });
  }

  _scrollToTop() {
    scroller.scrollTo('dashbaord-container', {
      duration: 800,
      smooth: true,
      offset: -100
    });
  }

  _closeAlert() {
    this.setState({
      alert: ''
    });
  }

  async serviceClickHandler(url, mode, confirmed) {
    this.setState({
      isButtonDisabled: true
    });
    this.url = url;
    this.mode = mode;

    // save mode and url for debugging purposes
    Utility.saveErrorDetails('serviceLinkHandlerClick', `${this.props.user.id},${mode},confirmed:${confirmed}`);

    if (mode == 'labtest') {
      url += `/${getLang()}`;
    } else if ((mode == 'askmedication' || mode == 'appointment') && !confirmed) {
      // check user's preferred pharmacy and log down request;
      let pharmacy = await Utility.getUserPharmacyStatus();
      if (!pharmacy) {
        // show modal
        this.togglePharmacyModal(true);
        return;
      }
    }

    let { user } = this.props;
    if (user.blocked) {
      this.setState({
        alert: 'Your account has been blocked. Please walk-in to the clinic during our regular business hours.',
        isButtonDisabled: false
      });
      return;
    }

    window.location.href = url;
  }

  _isAppointmentVisible(appType) {
    // appType ENUM I O D P M G

    let { appointmentType } = this.props.user;
    // console.log(appointmentType)
    return appointmentType.some(e => {
      return e.code == appType && e.status == 'enabled';
    });
  }

  togglePharmacyModal(val) {
    this.setState({
      showPharmacyModal: val
    });
  }
  cancelPharmacyModal() {
    this.setState({
      isButtonDisabled: false,
      showPharmacyModal: false
    });
  }
  async confirmPharmacyModal() {
    let selectedPharmacy = this.state.preferredPharmacy;
    if (!selectedPharmacy) {
      this.setState({
        alert: 'Please select the preferred pharmacy.'
      });
      return;
    }
    this.togglePharmacyModal(false);

    let data = {
      demographicNo: this.props.user.demographicNo,
      pharmacy: selectedPharmacy
    };
    await Utility.addPreferredPharmacy(data);
    this.serviceClickHandler(this.url, this.mode, true);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    if (!this.props.user) return null;

    if (this.state.shouldUpdate) return <Redirect to={'/account'}></Redirect>;

    let userVisibility = this.props.user.appVisibility && this.props.user.appVisibility.length !== 0 ? this.props.user.appVisibility : ['appointment'];
    let isAskmedBlocked = this.props.user.askmedBlocked;
    /*
        const isBcUser = this.props.user && this.props.user.careCard.province == "British Columbia";
        // const isBcUser = true;
        let {year,month,day} = this.props.user.birthday;
        let dob = moment(`${year}-${month}-${day}`);
        let years = moment().diff(moment(dob),'years');
        const isNotRestricted = (years >18 && isBcUser ) ? true : false;
        const isAskmedicationShown = ((this.props.user.eligibility == 'R' && years >18) || isNotRestricted ) ? true : false;
        const isLabtestShown = ((this.props.user.eligibility == 'R' && years >18) || isNotRestricted ) ? true : false;
        */

    const isLabtestShown = userVisibility.includes('asklabtest');
    const isAskmedicationShown = userVisibility.includes('askmedication') && !isAskmedBlocked;

    let token = localStorage.getItem('accessToken');

    const linkLabtest = `${config.order_labtest}/auth/${token}`;
    const linkAppointment = `${config.book_appointment}/auth/${token}/null`;

    const linkMedication = `${config.askmedication}/auth/${token}`;

    let appointmentText = 'Book an in-person, phone at the Richmond In-Store Medical Clinic.';
    let offlineText = <Translation>{t => <>{t('offline_text')}</>}</Translation>;

    const linkAppointmentICBC = `${config.book_appointment}/auth/${token}/I`;
    const linkAppointmentDriverPhysical = `${config.book_appointment}/auth/${token}/D`;

    let height = 130;

    if (this._isAppointmentVisible('I')) height += 56;

    if (window.innerWidth < 1160) height = '';

    const isTestSite = config.service.includes('api.test.southvanmed.com');

    return (
      <>
        {/* <Container> */}
        <Helmet>
          <title>Dashboard | Richmond In-Store Medical Clinic</title>
          <link rel="canonical" href="https://instoremed.com/dashboard" />

          <meta name="description" content="The Richmond In-Store Medical Clinic dasboard page " />
        </Helmet>

        <div id="dashbaord-container">
          {this.state.isConnecting && (
            <div className="alert alert-warning text-center" role="alert">
              Connecting to server... Please wait a moment.
            </div>
          )}
          <Modal
            header="Before proceeding, please select your preferred pharmacy"
            backdrop={'static'}
            show={this.state.showPharmacyModal}
            // hideCloseButton={true}
            dialogClassName={'modal-70w'}
            setShow={this.togglePharmacyModal.bind(this)}
            confirm={this.confirmPharmacyModal.bind(this)}
            cancelFunc={this.cancelPharmacyModal.bind(this)}
            message={this.renderPharmacyMessage()}
            confirmText="Confirm pharmacy"
            cancelText="Close"
            closeButton={false}
            keyboard={false}
            footerClass={'justify-content-center'}
          />
          <h1 className="center">
            <Translation>{t => <>{t('Instore Medical Clinic')}</>}</Translation>
          </h1>
          <div className="bottom-line"></div>
          <AlertDialog message={this.state.alert} onClose={this._closeAlert.bind(this)} />
          {this.state.isConnecting && (
            <div data-testid="cold-start-banner" style={{ background: '#d4edff', padding: '15px 20px', borderRadius: '6px', marginBottom: '25px', boxShadow: '0 3px 8px rgba(0,0,0,0.08)', borderLeft: '5px solid #0275d8' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <i className="fas fa-spinner fa-spin" style={{ color: '#0275d8', fontSize: '22px' }}></i>
                <span style={{ color: '#004085', lineHeight: '1.5', fontSize: '16px' }}>
                  Our server is waking up during quiet hours. This usually takes about a minute. Retrying automatically...
                </span>
              </div>
            </div>
          )}
          {/* Temporarily hidden - Form filling and Sick Note features in progress */}
          <Row>
            <Col sm={12} md={12} lg={6}>
              <Jumbotron className="stack-container">
                <div className="stack-top">
                  <span>Payment required</span>
                </div>
                <h1>
                  <Translation>{t => <>{t('Request a Form')}</>}</Translation>
                </h1>
                <p style={{ height: `${height}px` }} className={!this.state.isOscarOnline ? 'text-danger' : ''}>
                  {this.state.isOscarOnline ? (
                    <>
                      <Translation>{t => <>{t('Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes.')}</>}</Translation>
                      <span className={'text-danger'}>
                        &nbsp;
                        <Translation>{t => <>{t('In many cases, this can be done without coming to our medical clinic in person.')}</>}</Translation>
                      </span>
                    </>
                  ) : (
                    offlineText
                  )}
                </p>
                <p>
                  <button
                    className="btn btn-uni"
                    style={{ marginTop: '20px' }}
                    onClick={() => history.push('/medicalInfo?formType=school-work-form')}
                    disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                  >
                    <Translation>{t => <>{t('Request a Form')}</>}</Translation>
                  </button>
                </p>
              </Jumbotron>
            </Col>

            <Col sm={12} md={12} lg={6}>
              <Jumbotron className="stack-container">
                <div className="stack-top">
                  <span>Payment required</span>
                </div>
                <h1>
                  <Translation>{t => <>{t('Sick Note Request')}</>}</Translation>
                </h1>
                <p style={{ height: `${height}px` }} className={!this.state.isOscarOnline ? 'text-danger' : ''}>
                  {this.state.isOscarOnline ? (
                    <>
                      <Translation>{t => <>{t('Request a sick note (certificate for time off work or school due to illness) online.')}</>}</Translation>
                      <span className={'text-danger'}>
                        &nbsp;
                        <Translation>{t => <>{t('You obtain your sick note through email and likely would not need to come to our medical clinic in person.')}</>}</Translation>
                      </span>
                    </>
                  ) : (
                    offlineText
                  )}
                </p>
                <p>
                  <button
                    className="btn btn-uni"
                    style={{ marginTop: '20px' }}
                    onClick={() => history.push('/medicalInfo?formType=sick-note')}
                    disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                  >
                    <Translation>{t => <>{t('Request Sick Note')}</>}</Translation>
                  </button>
                </p>
              </Jumbotron>
            </Col>
          </Row>
          {/* Existing Services Section */}
          <Row>
            {(isLabtestShown || isAskmedicationShown) && (
              <Col sm={12} md={12} lg={6}>
                <Jumbotron className="stack-container">
                  <div className="stack-top">
                    <span>Payment required</span>
                  </div>
                  <h1
                    style={{
                      fontSize: '1.75rem',
                      minHeight: '2.5rem',
                      lineHeight: '2.5rem'
                    }}
                  >
                    <Translation>{t => <>{t('Medication and Testing')}</>}</Translation>
                  </h1>
                  <p style={{ height: `${height}px` }} className={!this.state.isOscarOnline ? 'text-danger' : ''}>
                    {this.state.isOscarOnline ? (
                      <>
                        <Translation>{t => <>{t('Ask the doctor to re-prescribe up to 5 medications per day using our')}</>}</Translation>{' '}
                        <span className="text-danger">
                          <Translation>{t => <>{t('Instore.AskMedication.com')}</>}</Translation>
                        </span>{' '}
                        <Translation>
                          {t => <>{t('website. Or request lab and radiology tests using our website. After a review by one of our physicians, the test form is emailed to you (')}</>}
                        </Translation>
                        <span className="text-danger">
                          <Translation>{t => <>{t('LifeLabs')}</>}</Translation>
                        </span>{' '}
                        <Translation>{t => <>{t('for lab testing) during our business hours.')}</>}</Translation>
                      </>
                    ) : (
                      offlineText
                    )}
                  </p>
                  <p>
                    {isAskmedicationShown && (
                      <button
                        className="btn btn-uni"
                        style={{ marginTop: '20px' }}
                        onClick={() => this.serviceClickHandler(linkMedication, 'askmedication')}
                        disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                      >
                        <Translation>{t => <>{t('Re-Prescribe Medications')}</>}</Translation>
                      </button>
                    )}
                    {isAskmedicationShown && isLabtestShown && <br />}
                    {isLabtestShown && (
                      <button
                        className="btn btn-uni"
                        style={{ marginTop: '20px' }}
                        onClick={() => this.serviceClickHandler(linkLabtest, 'labtest')}
                        disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                      >
                        <Translation>{t => <>{t('Request Lab and Radiology Testing')}</>}</Translation>
                      </button>
                    )}
                  </p>
                </Jumbotron>
              </Col>
            )}
            <Col sm={12} md={12} lg={6}>
              <Jumbotron>
                <h1>
                  <Translation>{t => <>{t('Book Appointment')}</>}</Translation>
                </h1>
                <p style={{ height: `${height}px` }} className={!this.state.isOscarOnline ? 'text-danger' : ''}>
                  {this.state.isOscarOnline ? (
                    <>
                      <Translation>{t => <>{t(appointmentText)}</>}</Translation>
                    </>
                  ) : (
                    offlineText
                  )}
                </p>
                <p>
                  <button
                    className="btn btn-uni"
                    style={{ marginTop: '20px' }}
                    onClick={() => this.serviceClickHandler(linkAppointment, 'appointment')}
                    disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                  >
                    <Translation>{t => <>{t('Book family medicine appointment')}</>}</Translation>
                  </button>
                  <br />

                  {this._isAppointmentVisible('I') ? (
                    <button
                      className="btn btn-uni"
                      style={{ marginTop: '20px' }}
                      onClick={() => this.serviceClickHandler(linkAppointmentICBC, 'appointment')}
                      disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                    >
                      <Translation>{t => <>{t('Book ICBC appointment')}</>}</Translation>
                    </button>
                  ) : null}
                  {this._isAppointmentVisible('I') ? <br /> : null}
                  {this._isAppointmentVisible('D') ? (
                    <button
                      className="btn btn-uni"
                      style={{ marginTop: '20px' }}
                      onClick={() => this.serviceClickHandler(linkAppointmentDriverPhysical, 'appointment')}
                      disabled={!this.state.isOscarOnline || this.state.isButtonDisabled}
                    >
                      <Translation>{t => <>{t("Book Driver's medical examination")}</>}</Translation>
                    </button>
                  ) : null}
                </p>
              </Jumbotron>
            </Col>
          </Row>
        </div>
        {/* </Container> */}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    pharmacy: state.pharmacy
  };
};

const mapDispatchToProps = {
  addPreferredPharmacy
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
